module.exports = __webpack_public_path__ + "img/choose-shape.393e90b6.png";